import { render, staticRenderFns } from "./cataloguePOS.vue?vue&type=template&id=815eb10e&scoped=true&"
import script from "./cataloguePOS.vue?vue&type=script&lang=js&"
export * from "./cataloguePOS.vue?vue&type=script&lang=js&"
import style0 from "./cataloguePOS.vue?vue&type=style&index=0&id=815eb10e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815eb10e",
  null
  
)

export default component.exports